import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scrolls the window (and any inner scroll containers) to the top on every route change.
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    // instant so kids don't see a jarring animation on every tap
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

export default ScrollToTop;
